import { RadioTypes } from "../../../commonTypes/universalTypes";
import { TableHeadersType } from "../tableHeadersType";

export const ID_PASSWORD_MANAGER_HEADERS: TableHeadersType[] = [
  {
    label: 'Title',
    value: 'title',
    checked: true,
    defaultChecked: true
  },
  {
    label: 'Client Name',
    value: 'client_name',
    checked: true,
    defaultChecked: true
  },
  {
    label: 'Category',
    value: 'category',
    checked: true,
    defaultChecked: true
  },
  {
    label: 'URL',
    value: 'url',
    checked: true,
    defaultChecked: true
  },
  {
    label: 'Login Id',
    value: 'login_id',
    checked: true,
    defaultChecked: true
  },
  {
    label: 'Password',
    value: 'password',
    checked: true,
    defaultChecked: true
  },
  {
    label: 'Access Members',
    value: 'access_member_ids',
    checked: true,
    defaultChecked: true
  },
  {
    label: 'File Attachment',
    value: 'files',
    checked: true,
    defaultChecked: true
  },
  {
    label: 'Added/Modified By',
    value: 'updated_at',
    checked: true,
    defaultChecked: true
  },
  {
    label: 'Edit',
    value: 'edit',
    checked: true,
    defaultChecked: true
  },

]

export const FILE_ATTACHMENT_RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "",
    name: "All",
  },
  {
    id: "1",
    name: "With files",
  },
  {
    id: "0",
    name: "Without files",
  },
 
];
